(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("4v4Tw", function(module, exports) {

$parcel$export(module.exports, "initProductFiltration", function () { return $346ddaa33273c85c$export$2fc0f79e5d3f9bc2; });

var $ogxQy = parcelRequire("ogxQy");

var $emIQL = parcelRequire("emIQL");
const $346ddaa33273c85c$export$2fc0f79e5d3f9bc2 = async ()=>{
    const responseSettings = {
        method: "GET"
    };
    const section = document.querySelector(".s-product-list");
    const empty = document.querySelector(".s-product-list__empty");
    const filterBody = document.querySelector(".f-filtration__body");
    const selectedList = document.querySelector(".i-filtration-visual");
    if (!section) return;
    const group = section?.querySelector(".g-product");
    const groupCategories = document?.querySelector(".g-categories, .f-category__items");
    const itemLimit = group?.dataset.limit;
    const paginationWrapper = section?.querySelector(".--js-pagination-wrap");
    const getApiUrl = (page)=>{
        const apiBase = `/front/api/product-list/products/`;
        const apiUrl = new URL(`${window.location.origin}${apiBase}`);
        const newFilter = document.querySelector(".f-filtration__form");
        const newFormCategory = document.querySelector(".f-category");
        const categoryId = newFilter?.dataset.categoryId;
        const familyId = newFilter?.dataset.familyId;
        if (newFilter) new FormData(newFilter).forEach((value, name)=>{
            if (value) apiUrl.searchParams.append(name, value.toString());
        });
        if (newFormCategory) new FormData(newFormCategory).forEach((value, name)=>{
            if (value) apiUrl.searchParams.append(name, value.toString());
        });
        if (page) apiUrl.searchParams.append("page", page);
        if (itemLimit) apiUrl.searchParams.append("limit", itemLimit);
        if (categoryId) apiUrl.searchParams.append("categoryId", categoryId);
        if (familyId) apiUrl.searchParams.append("familyId", familyId);
        return apiUrl.toString();
    };
    const dispatchFilterEvent = ()=>{
        section?.dispatchEvent(new Event("filter"));
    };
    const dispatchFilterEventDebounced = (0, $ogxQy.debounce)(()=>dispatchFilterEvent());
    const filterProducts = async (page)=>{
        group?.classList.add("--loading");
        groupCategories?.classList.add("--loading");
        filterBody?.classList.add("--loading");
        setDisabled();
        const response = await (0, $emIQL.makeRequest)(getApiUrl(page), responseSettings);
        if (!response.ok) {
            group?.classList.remove("--loading");
            groupCategories?.classList.remove("--loading");
            filterBody?.classList.remove("--loading");
            return;
        }
        const data = await response.json();
        if (data.success) {
            history.replaceState(null, "", data.url);
            if (!data.html) {
                empty?.classList.remove("--hidden");
                group?.classList.add("--hidden");
            } else {
                empty?.classList.add("--hidden");
                group?.classList.remove("--hidden");
            }
            if (filterBody) filterBody.innerHTML = data.filter ?? "";
            inputsInit();
            if (selectedList) selectedList.innerHTML = data.selected ?? "";
            if (group) group.innerHTML = data.html;
            if (groupCategories) groupCategories.innerHTML = data.categoryItems ?? "";
            categoriesInit();
            if (paginationWrapper) paginationWrapper.innerHTML = data.pagination ?? "";
            paginationInit();
        }
        group?.classList.remove("--loading");
        groupCategories?.classList.remove("--loading");
        filterBody?.classList.remove("--loading");
        setEnabled();
        document.dispatchEvent(new Event("rangeReinit"));
        document.dispatchEvent(new Event("checkboxSelectReinit"));
        document.dispatchEvent(new Event("overlayscrollbarsReinit"));
        document.dispatchEvent(new Event("filterListReinit"));
        document.dispatchEvent(new Event("filterClearReinit"));
        window.lazyloading?.update();
    };
    const setDisabled = ()=>{
        const filter = document.querySelector(".f-filtration__form");
        const inputs = filter?.querySelectorAll("input[name]");
        inputs?.forEach((input)=>{
            if (input.value == input.min || input.value == input.max) input.disabled = true;
        });
    };
    const setEnabled = ()=>{
        const filter = document.querySelector(".f-filtration__form");
        const inputs = filter?.querySelectorAll("input[name]");
        inputs?.forEach((input)=>{
            if ((input.value == input.min || input.value == input.max) && input.min !== input.max) input.disabled = false;
        });
    };
    section?.addEventListener("filter", async ()=>{
        await filterProducts();
    });
    const inputsInit = ()=>{
        const newFilter = document.querySelector(".f-filtration__form");
        const newInputs = newFilter?.querySelectorAll("input[name]");
        newInputs?.forEach((input)=>input.addEventListener("change", dispatchFilterEventDebounced));
    };
    inputsInit();
    const categoriesInit = ()=>{
        const newFormCategory = document.querySelector(".f-category");
        const newCategories = newFormCategory?.querySelectorAll("input[name]");
        newCategories?.forEach((category)=>category.addEventListener("change", dispatchFilterEventDebounced));
    };
    categoriesInit();
    const paginationInit = ()=>{
        const paginationLinks = paginationWrapper?.querySelectorAll(".c-pagination__link");
        paginationLinks?.forEach((link)=>link.addEventListener("click", async (event)=>{
                event.preventDefault();
                const page = link.dataset.page ?? "";
                await filterProducts(page).then(()=>{
                    section?.scrollIntoView({
                        behavior: "instant",
                        block: "start"
                    });
                });
            }));
    };
    paginationInit();
};
$346ddaa33273c85c$export$2fc0f79e5d3f9bc2();

});
parcelRegister("ogxQy", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $048f137b14a33e13$export$61fc7d43ac8f84b0; });
const $048f137b14a33e13$export$61fc7d43ac8f84b0 = (fn, delay = 500)=>{
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn.apply(this, args);
        }, delay);
    };
};

});

parcelRegister("emIQL", function(module, exports) {

$parcel$export(module.exports, "makeRequest", function () { return $a755e9075ec5f98f$export$699251e5611cc6db; });
const $a755e9075ec5f98f$export$699251e5611cc6db = async (url, options)=>{
    try {
        const response = await fetch(url, {
            ...options
        });
        console.log(response);
        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
        return response;
    } catch (error) {
        console.error("An error occurred:", error);
        throw error; // Propagate the error for handling at a higher level if needed
    }
};

});


})();
//# sourceMappingURL=product-filtration-handle.f8ed05fb.js.map
